module.exports = "//static.hsappstatic.net/salesImages/static-1.403/email-images/sidekick-messages-logo.png"